// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar-rating {
  display: flex;
  align-items: center;
  margin-left: 15px;
  margin-top: 1px;
  padding-right: 5px;
}

.star-icon {
  font-size: 9px;
  margin-right: 3px;
}

.big-bold {
  font-size: 60px;
  font-weight: bold;
}

.review-content {
  width: 100%;
  overflow: auto;
  height: 190px;
  max-height: 190px;
  padding: 15px;
  margin: 0;
}

.swiper-slide {
  width: 95%;
}

.star-rating-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.star-rating-container ion-icon {
  color: #ff9800;
  font-size: 1.3rem;
  margin-right: 2px;
}

.user-info-container {
  margin-top: 10px;
}

.text-bold {
  font-weight: bold;
}

.user-comment {
  text-align: justify;
  margin-top: 10px;
}

.user-info {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: transparent;
  margin-right: 10px;
}

.img-user {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.reviews-row {
  --ion-grid-columns: 5;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  margin-left: calc(var(--page-margin) * -1);
  margin-right: calc(var(--page-margin) * -1);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.reviews-row::-webkit-scrollbar {
  display: none;
}
.reviews-row::before, .reviews-row::after {
  content: "";
  flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));
}
.reviews-row .reviews-item {
  --col-item-width: 4;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-friends-gutter);
}`, "",{"version":3,"sources":["webpack://./src/app/components/experiences/experience-review-list/experience-review-list.page.scss","webpack://./src/theme/mixins/scrollbars.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AADF;;AAIA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,2CAAA;EC7EA,wBAAA;EAGA,8BAAA;EACA,qBAAA;AD0EF;ACvEE;EACE,aAAA;ADyEJ;AAAE;EAEE,WAAA;EAEA,+DAAA;AAAJ;AAGE;EACE,mBAAA;EAEA,0EAAA;EAEA,uEAAA;EAGA,2EAAA;EAIA,uCAAA;AARJ","sourcesContent":["@import \"theme/mixins/scrollbars\";\r\n\r\n.progress-bar-rating {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 15px;\r\n  margin-top: 1px;\r\n  padding-right: 5px;\r\n}\r\n\r\n.star-icon {\r\n  font-size: 9px;\r\n  margin-right: 3px;\r\n}\r\n\r\n.big-bold {\r\n  font-size: 60px;\r\n  font-weight: bold;\r\n}\r\n\r\n.review-content {\r\n  width: 100%;\r\n  overflow: auto;\r\n  height: 190px;\r\n  max-height: 190px;\r\n  padding: 15px;\r\n  margin: 0;\r\n}\r\n\r\n.swiper-slide {\r\n  width: 95%;\r\n}\r\n\r\n.star-rating-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.star-rating-container ion-icon {\r\n  color: #ff9800;\r\n  font-size: 1.3rem;\r\n  margin-right: 2px;\r\n}\r\n\r\n.user-info-container {\r\n  margin-top: 10px;\r\n}\r\n\r\n.text-bold {\r\n  font-weight: bold;\r\n}\r\n\r\n.user-comment {\r\n  text-align: justify;\r\n  margin-top: 10px;\r\n}\r\n\r\n.user-info {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  background-color: transparent;\r\n  margin-right: 10px;\r\n}\r\n\r\n.img-user {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.reviews-row {\r\n  --ion-grid-columns: 5; // We want to show three friends and a half. Each friend fills 2 cols => (3.5 * 3 = 7 cols)\r\n  --ion-grid-column-padding: 0px;\r\n\r\n  flex-wrap: nowrap;\r\n  overflow-x: scroll;\r\n  will-change: scroll-position;\r\n  margin-left: calc(var(--page-margin) * -1);\r\n  margin-right: calc(var(--page-margin) * -1);\r\n\r\n  @include hide-scrollbars();\r\n\r\n  &::before,\r\n  &::after {\r\n    content: \"\";\r\n    // .friend-item has 8px of side padding, we need an extra 4px at the beginning and end to fill the 12px side margin of the view\r\n    flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));\r\n  }\r\n\r\n  .reviews-item {\r\n    --col-item-width: 4;\r\n    // SSR fix: Override ion-col styles\r\n    flex: 0 0\r\n      calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n    width: calc(\r\n      calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%\r\n    );\r\n    max-width: calc(\r\n      calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%\r\n    );\r\n\r\n    padding: 0px var(--page-friends-gutter);\r\n  }\r\n}\r\n","// Hide scrollbars: https://stackoverflow.com/a/38994837/1116959\r\n@mixin hide-scrollbars() {\r\n  // IE 10+\r\n  -ms-overflow-style: none;\r\n\r\n  // Firefox\r\n  overflow: -moz-scrollbars-none;\r\n  scrollbar-width: none;\r\n\r\n  // Safari and Chrome\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
